import React from 'react';
import EmptyConfig from '../EmptyConfig';

interface TableWrapperProps {
  isSearch?: boolean;
}
/**
 * 공통적으로 적용할 데이터를 여기서 관리하고 해당 정보를 적용한 테이블 컴포넌트를 주입받아 그리는 컴포넌트
 * facc 참고 https://react-etc.vlpt.us/04.render-prop.html
 */
const TableWrapper = ({ children, isSearch }: React.PropsWithChildren<TableWrapperProps>): React.ReactElement => {
  /* ======================================================
   * render items
   * ====================================================== */
  return (
    <EmptyConfig desc={isSearch ? '검색 결과가 없습니다.' : '등록된 정보가 없습니다.'}>
      {children}
    </EmptyConfig>
  );
};

export default TableWrapper;
